import find from 'lodash/find';
import { giaItemsSelector } from '../gia/selectors';
import { CHANGE_GIA_ITEM } from '../constants';
import { resetAppeal } from '../appealFind/actions';

const filterChars = (value, field) => {
  if (field === 'document_number') {
    return value.replace(/[^0-9a-zа-я-]+/gi, '');
  }

  return value.replace(/[^0-9]+/gi, '');
};

export const giaMiddleware = ({ dispatch, getState }) => next => action => {
  if (action.type !== CHANGE_GIA_ITEM) {
    return next(action);
  }

  const {
    payload: { field, value }
  } = action;
  const valueReplaced = filterChars(value, field);

  const state = getState();
  const giaItems = giaItemsSelector(state);
  let mappedItem = {
    field
  };

  const selectedItem = find(
    giaItems,
    item => item[field] === valueReplaced,
    null
  );

  dispatch(resetAppeal());

  // это условие срабатывает при выборе значения в выпадающем списке
  if (selectedItem) {
    mappedItem = {
      registration_code: {
        value: selectedItem.registration_code,
        valid: true,
        message: null
      },
      document_number: {
        value: selectedItem.document_number,
        valid: true,
        message: null
      }
    };
    return next({ type: CHANGE_GIA_ITEM, payload: mappedItem });
  }

  mappedItem[field] = {
    value: valueReplaced,
    valid: true,
    message: null
  };

  return next({ type: CHANGE_GIA_ITEM, payload: mappedItem });
};

export default giaMiddleware;
